import React from "react";
import { Input } from "antd";

export interface CustomOtpProps {
  otp: string;
  setOtp: (value: string) => void;
  length?: number;
}

export const CustomOtp: React.FC<CustomOtpProps> = ({ otp, setOtp, length = 6 }) => {
  return (
    <div className="flex w-full justify-center mb-4 mt-2">
      <Input
        value={otp}
        onChange={(e) => {
          const value = e.target.value.replace(/[^0-9]/g, "").slice(0, length);
          setOtp(value);
        }}
        inputMode="numeric"
        placeholder="Enter verification code"
        maxLength={length}
        size="large"
        className="max-w-[260px] text-center tracking-[0.3em]"
      />
    </div>
  );
};

export default CustomOtp;

